module Meevo.Plugins.Register {
    "use strict";

    export class PackageTransferSection extends Meevo.Plugins.Register.RegisterSectionBase {

        protected memberPackages: any[];
        protected otherPackages: any[];
        protected selectedSaleLine: Model.SaleLine;
        public client: any;
        public clientPackageNumber: string;
        public includeExpiredRemaining: boolean;
        public selectedClients: any[];
        public offsitePackageTransferSecurityItem: Model.SecurityItem;
        public securityKeys = Meevo.Components.Common.SecurityKeys;

        get $q() { return this.registerContext.$q; }       
        get $rootScope() { return this.registerContext.$rootScope; }
        get $translate() { return this.registerContext.$translate; }
        get appSettings() { return this.registerContext.appSettings; }
        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get securityService() { return this.registerContext.securityService; }
        get identityService() { return this.registerContext.identityService; }
        get busyService() { return this.registerContext.busyService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.PackageTransfer, registerContext, "packageTransfer", Register.RegisterSectionCatTypeEnum.Other);

            this.securityService.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_OFFSITE_TRANSFERSERVICEOVERRIDE).then((securityItem) => {
                this.offsitePackageTransferSecurityItem = securityItem;
            });
        }

        reset() {
            this.memberPackages = [];
            this.otherPackages = [];
            this.selectedSaleLine = null;
            this.client = null;
            this.clientPackageNumber = null;
            this.includeExpiredRemaining = false;
            this.registerContext.hideCheckoutButtons = false;
            this.selectedClients = [];
        }

        edit(saleLine: Model.SaleLine) {
            this.selectedSaleLine = saleLine;
            this.registerContext.hideCheckoutButtons = true;
            if (this.selectedSaleLine.clientType == Meevo.Model.ClientTypeEnum.Client && this.selectedSaleLine.clientId) {
                this.selectedClients.push({ id: this.selectedSaleLine.clientId });
            }
        }

        getAvailablePackages() {
            var unsoldClientPackageIds = [];
            var usedPackageServiceIds = [];
            var usedPackageProductIds = [];
            this.registerContext.sale.saleLines.forEach((sl) => {
                if (sl.clientType == Model.ClientTypeEnum.Client && sl.clientId == this.selectedSaleLine.clientId) {
                    if (this.registerContext.isSaleLineItemRedeemableWithPackage(sl) && sl.packageRedeemed) {
                        sl.redeemedPackages.forEach((rp) => {
                            rp.packageServices.forEach((ps) => {
                                usedPackageServiceIds.push(ps.id);
                            });
                            rp.packageProducts.forEach((pp) => {
                                usedPackageProductIds.push(pp.id);
                            })
                        });
                    }
                    else if (sl.saleType == Model.SalesTypeEnum.Package || sl.saleType == Model.SalesTypeEnum.PackageMerge || sl.saleType == Model.SalesTypeEnum.PackageSplit || sl.saleType == Model.SalesTypeEnum.PackageTransfer) {
                        unsoldClientPackageIds.push(sl.item.id);
                    }
                }
            });

            var request: Model.SearchPage<any, any> = {
                itemsPerPage: 1000,
                pageNumber: 0,
                criteria: {
                    clientId: this.selectedSaleLine.clientId,
                    itemId: this.selectedSaleLine.item.id,
                    donorClientId: this.client ? this.client.id : null,
                    donorPackageNumber: this.clientPackageNumber,
                    includeExpiredRemaining: this.includeExpiredRemaining,
                    usedPackageItemIds: [...usedPackageServiceIds, ...usedPackageProductIds],
                    unsoldClientPackageIds: unsoldClientPackageIds,
                    saleType: this.selectedSaleLine.saleType,
                    currentDateTime: this.registerContext.sale.pastTransactionDateTime,
                    isGlobal: this.registerContext.allowCustomPackageRedemptionAtAnyLocation,
                }
            };
            this.dataService.getListPaged("ClientPackageTransfer", request).then((packages) => {
                // filter out transferred services already
                packages.forEach((pkg) => {
                    this.registerContext.sale.saleLines.forEach((sl) => {
                        var packageTransferItem = (sl.item as ClientPackageTransferSaleLineItem);
                        if (sl.saleType == Model.SalesTypeEnum.PackageTransfer) {
                            for (var k = pkg.clientPackageServiceTransferList.length - 1; k >= 0; k--) {
                                if (packageTransferItem.donorClientPackageServiceId == pkg.clientPackageServiceTransferList[k].id) {
                                    pkg.clientPackageServiceTransferList.splice(k, 1);
                                }
                            }

                            for (var k = pkg.clientPackageProductTransferList.length - 1; k >= 0; k--) {
                                if (packageTransferItem.donorClientPackageProductId == pkg.clientPackageProductTransferList[k].id) {
                                    pkg.clientPackageProductTransferList.splice(k, 1);
                                }
                            }
                        }
                    });
                });
                this.memberPackages = _.filter(packages, (item) => item.clientMembershipId != null && item.clientMembershipId != "");
                this.otherPackages = _.filter(packages, (item) => item.clientMembershipId == null || item.clientMembershipId == "");

                // filter out package services in both that are being used within the sale
                let packageItemIdsUsedInSale: any[] = [];
                this.registerContext.sale.saleLines.forEach((sl) => {
                    if (sl.redeemedPackages && sl.redeemedPackages.length > 0) {
                        sl.redeemedPackages.forEach((pkg) => {
                            [...pkg.packageServices, ...pkg.packageProducts].forEach((pi) => {
                                packageItemIdsUsedInSale.push(pi.id);
                            });
                        });
                    }
                    else if (sl.saleType == Model.SalesTypeEnum.PackageMerge || sl.saleType == Model.SalesTypeEnum.PackageSplit) {
                        let psl = (sl.item as PackageSaleLineItem);
                        if (psl && psl.clientPackage) {
                            packageItemIdsUsedInSale.push(...psl.clientPackage.sourceClientPackageServiceIds);
                        }
                    }
                    else if (sl.saleType == Model.SalesTypeEnum.PackageTransfer) {
                        let cpsl = (sl.item as ClientPackageTransferSaleLineItem);
                        if (cpsl && cpsl.donorClientPackageServiceId) {
                            packageItemIdsUsedInSale.push(cpsl.donorClientPackageServiceId);
                        }
                    }
                    else if (sl.saleType == Model.SalesTypeEnum.Package && sl.isRefund) {
                        let rpsl = (sl.item as PackageSaleLineItem);
                        if (rpsl && rpsl.clientPackage) {
                            _.each([...rpsl.clientPackage.packageServices, ...rpsl.clientPackage.packageProducts], 
                                (rpi: any) => {
                                    packageItemIdsUsedInSale.push(rpi.id);
                            });
                        }
                    }
                });

                this.memberPackages.forEach((pkg) => {
                    pkg.clientPackageServiceTransferList = _.filter(pkg.clientPackageServiceTransferList, (item: any) => { return _.find(packageItemIdsUsedInSale, (idInSale) => { return idInSale == item.id }) == null; });
                });
                this.otherPackages.forEach((pkg) => {
                    pkg.clientPackageServiceTransferList = _.filter(pkg.clientPackageServiceTransferList, (item: any) => { return _.find(packageItemIdsUsedInSale, (idInSale) => { return idInSale == item.id }) == null; });
                    pkg.clientPackageProductTransferList = _.filter(pkg.clientPackageProductTransferList, (item: any) => { return _.find(packageItemIdsUsedInSale, (idInSale) => { return idInSale == item.id }) == null; });
                    pkg.clientPackageItemTransferList = [...pkg.clientPackageServiceTransferList, ...pkg.clientPackageProductTransferList];
                });
            });
        }

        getPackageRedemptionIcon(item, pkg) {
            const baseUrl = "assets/images/icons/";
            switch (item.packageRedemptionType) {
                case Model.PackageRedemptionTypeEnum.ExactMatch:
                    return baseUrl + (pkg.isExpired ? "package_match_expired.svg" : "package_match.svg");
                case Model.PackageRedemptionTypeEnum.Swap:
                case Model.PackageRedemptionTypeEnum.Split:
                case Model.PackageRedemptionTypeEnum.Merge:
                    return baseUrl + (pkg.isExpired ? "package_expired.svg" : "packages.svg");
            }
            return null;
        }

        cancel() {
            this.reset();
            this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
        }

        transfer(isValid, suppressWarnings: boolean = false) {
            if (!isValid) {
                return;
            }

            // create package first
            const unsoldPackageTransferSaleLines = _(this.registerContext.sale.saleLines)
                .filter(saleLine => !saleLine.isRefund && saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageTransfer);

            const transferRequest = {
                clientPackages: [],
                clientId: this.selectedSaleLine.clientId,
                suppressWarnings: suppressWarnings,
                unsoldPackageTransferSaleLines: unsoldPackageTransferSaleLines,
                currentDateTime: this.registerContext.sale.pastTransactionDateTime,
                allowCustomPackageRedemptionAtAnyLocation: this.registerContext.allowCustomPackageRedemptionAtAnyLocation,
            };

            this.memberPackages.forEach((pkg) => {
                pkg.clientPackageServiceTransferList.forEach((cps) => {
                    if (cps.isTransfer) {
                        var newPackage = _.clone(pkg);
                        cps.quantity = 1;
                        newPackage.clientPackageServiceTransferList = [cps];
                        transferRequest.clientPackages.push(newPackage);
                    }
                });
            });

            this.otherPackages.forEach((pkg) => {
                pkg.clientPackageItemTransferList.forEach(cpi => {
                    if (cpi.isTransfer) {
                        var newPackage = _.clone(pkg);
                        if(cpi.serviceId && cpi.serviceId.length > 0) {
                            newPackage.clientPackageServiceTransferList = [cpi];
                            newPackage.clientPackageProductTransferList = [];
                        } else {
                            newPackage.clientPackageProductTransferList = [cpi];
                            newPackage.clientPackageServiceTransferList = [];
                        }
                        transferRequest.clientPackages.push(newPackage);
                    }
                })
            });

            if (transferRequest.clientPackages.length === 0) {
                return;
            }

            const url =`/${this.appSettings.API_ROOT}/clientPackageTransfer`;

            const transferRequestParams = {
                skipInterceptor: !suppressWarnings
            };

            this.busyService.start();

            this.dataService.customMethodData(url, 'POST', transferRequest, transferRequestParams)
                .then((response) => {
                    response.data.forEach((clientPackage) => {
                        const isPackageTransferOverride = suppressWarnings;
                        const donorClientItemIds = [...clientPackage.donorClientServiceIds, ...clientPackage.donorClientProductIds];
                        const isServiceTransfer = clientPackage.donorClientServiceIds && clientPackage.donorClientServiceIds.length > 0;

                        this.registerContext.addClientPackageTransferSaleLineWorker(
                            clientPackage,
                            donorClientItemIds,
                            clientPackage.transferFee || 0,
                            isPackageTransferOverride,
                            transferRequest.clientPackages[0].clientId, // all packages should have same client id
                            isServiceTransfer,
                        );
                    });

                    this.selectedSaleLine.performAutoRedeem = true;

                    this.registerContext.recalculateSale().then(() => {
                        this.busyService.stop();
                        this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
                    });
                })
                .catch((response) => {
                    this.busyService.stop();

                    if (suppressWarnings) {
                        return;
                    }

                    const header = this.$translate.instant("MESSAGE_PACKAGE_TRANSFER_HEADER");
                    const messages = response.data.responseStatus.errors.map((error) => '<li>' + error.message + '</li>');
                    const messageList = '<ul>' + messages.join('') + '</ul>';
                    const prompt = this.$translate.instant("MESSAGE_PACKAGE_TRANSFER_PROMPT");

                    if (this.securityService.hasSecurity(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICEOVERRIDE)) {
                        const message = header + messageList + prompt;

                        this.modalService.confirm(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                            this.transfer(isValid, true);
                        });
                    } else {
                        this.securityService.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICEOVERRIDE).then((item: Model.SecurityItem) => {
                            const message = header + messageList + prompt;

                            if (item.securityAccess === Model.SecurityAccessEnum.Deny && item.canElevate) {
                                this.modalService.confirm(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                                    let defer = this.$q.defer();
                                    defer.promise.then(() => {
                                        this.transfer(isValid, true);
                                    });
                                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, item.key.replace(/:/gi, '_'), item.displayName, this.identityService.current().userName, item.securityKeyPath);
                                });
                            }
                            else {
                                const message = header + messageList;

                                this.modalService.warning(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                            }
                        });
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        isTransferCheckboxDisabled(memberPackage) {
            if (!memberPackage) {
                return true;
            }

            if (!memberPackage.isShareable) {
                return true;
            }

            if (memberPackage.isOffsiteTransferable === false) {
                if (memberPackage.isElevated) {
                    return false;
                }

                if (this.offsitePackageTransferSecurityItem.securityAccess === Model.SecurityAccessEnum.Grant) {
                    return false;
                }

                if (this.offsitePackageTransferSecurityItem.securityAccess === Model.SecurityAccessEnum.Deny && 
                    this.offsitePackageTransferSecurityItem.canElevate) {
                    memberPackage.isElevatable = true;
                    return false;
                }

                return true;
            }

            return false;
        }

        isServiceTransferable(service) {
            return !service.isServiceNonTransferable; 
        }

        isAnyMembershipPackageServiceTransferable() {
            if (this.memberPackages && this.memberPackages.length > 0) {
                let retVal = false;
                _(this.memberPackages).each((pkg) => {
                    let isAny = _(pkg.clientPackageServiceTransferList).any(svc => !svc.isServiceNonTransferable);
                    if (isAny)
                        retVal = true;
                });
                return retVal;
            }
            return false;
        }

        checkedPackage(pkg, item) {
            if (!pkg) {
                return true;
            }

            if (pkg.isElevated) {
                return true;
            }

            if (pkg.isOffsiteTransferable === false) {
                if (this.offsitePackageTransferSecurityItem.securityAccess === Model.SecurityAccessEnum.Deny && 
                    this.offsitePackageTransferSecurityItem.canElevate) {
                    let defer = this.$q.defer();

                    defer.promise.then(() => {
                        // apply this elevation to all other services in same package needing elevation
                        _(this.memberPackages).each((memberPackage) => {
                            if (memberPackage.clientMembershipId === pkg.clientMembershipId && 
                                memberPackage.isElevatable &&
                                memberPackage.isOffsiteTransferable === false) {
                                memberPackage.isElevated = true;
                            }
                        });

                        item.isTransfer = true;
                    });

                    this.$rootScope.$broadcast(
                        Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, 
                        defer, 
                        this.offsitePackageTransferSecurityItem.key.replace(/:/gi, '_'), 
                        this.offsitePackageTransferSecurityItem.displayName, 
                        this.identityService.current().userName, 
                        this.offsitePackageTransferSecurityItem.securityKeyPath
                    );

                    return false;
                }
            }

            return true;
        }
    }
}